import { useEffect, useState } from 'react'
import { fetchPointCardOffers } from 'repos/pointCard/pointCardOffer'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getPointCard } from 'reducks/pointCard/selectors'
import { PointCardOfferType as BasePointCardOfferType } from 'types/pointCard/pointCardOffer'
import { FirebaseDocRefType } from 'firebase/index'
type PointCardOfferType = BasePointCardOfferType & { ref: FirebaseDocRefType }

const useFetchPointCardOffers = () => {
  const pointCard = useSelector((state: State) => getPointCard(state))
  const [pointCardOffers, setPointCardOffers] = useState<PointCardOfferType[]>([])

  useEffect(() => {
    ;(async () => {
      if (!pointCard) return
      const res = await fetchPointCardOffers(pointCard.ref.id)
      if (!res) return
      setPointCardOffers(res)
    })()
  }, [pointCard])

  return {
    pointCardOffers,
  }
}

export default useFetchPointCardOffers
